import { render } from "./UploadList.vue?vue&type=template&id=375bb0de"
import script from "./UploadList.vue?vue&type=script&lang=js"
export * from "./UploadList.vue?vue&type=script&lang=js"

import "./UploadList.vue?vue&type=style&index=0&id=375bb0de&lang=css"

import exportComponent from "/Users/aml/Projects/dashboardcopy2/fnbxv21-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__